import { Client } from "app/components/app/class/client";

export class responseClientList{
    list:Array<Client>;
    constructor(data){
        this.list = data.map(item => new Client(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-client-list.ts